// extracted by mini-css-extract-plugin
module.exports = {"LoginBox":"LoginBox_LoginBox__2ug0o"};